import { bunja } from 'bunja';
import { atom } from 'jotai';
import { atomWithDefault } from 'jotai/utils';

import { LocalStorage, getLocalStorage, setLocalStorage } from '@flipster/utils/localStorage';

export const shareThisTradeBunja = bunja(() => {
  const shareThisTradeCheckedBaseAtom = atomWithDefault(
    () =>
      getLocalStorage('flipster.configs.v1.shareThisTradeChecked') ??
      (() => (setLocalStorage('flipster.configs.v1.shareThisTradeChecked', false), false))(),
  );
  const shareThisTradeCheckedAtom = atom(
    (get) => get(shareThisTradeCheckedBaseAtom),
    (get, set) => {
      const next = !get(shareThisTradeCheckedBaseAtom);
      setLocalStorage('flipster.configs.v1.shareThisTradeChecked', next);
      return set(shareThisTradeCheckedBaseAtom, next);
    },
  );

  const shareThisTradeNudgeStateBaseAtom = atomWithDefault(
    () =>
      getLocalStorage('flipster.configs.v1.shareThisTradeNudgeState') ??
      (() => (setLocalStorage('flipster.configs.v1.shareThisTradeNudgeState', ['UNSEEN']), ['UNSEEN'] as const))(),
  );
  const shareThisTradeNudgeStateAtom = atom(
    (get) => get(shareThisTradeNudgeStateBaseAtom),
    (_, set, state: LocalStorage['flipster.configs.v1.shareThisTradeNudgeState']) => {
      setLocalStorage('flipster.configs.v1.shareThisTradeNudgeState', state);
      return set(shareThisTradeNudgeStateBaseAtom, state);
    },
  );

  return { shareThisTradeCheckedAtom, shareThisTradeNudgeStateAtom };
});
shareThisTradeBunja.debugLabel = 'shareThisTradeBunja';
